import React from 'react'
import styled from 'react-emotion'
import Logo from './Logo'
import SiteLinks from './SiteLinks'

const NavContainer = styled.nav`
  align-items: center;
  display: flex;
  justify-content: space-between;
`

const NavBar = () => (
  <NavContainer>
    <Logo />
    <SiteLinks />
  </NavContainer>
)

export default NavBar



// WEBPACK FOOTER //
// ./src/components/NavBar/index.js